import RecordRTC from 'recordrtc';
import { SnackBarHelper } from '@lyearn-team/frontend-components';
import autobind from 'autobind-decorator';
import Base from '.';

const mediaConstraints = { video: { width: 1280, height: 720 }, audio: true };

export default class videoRecorder extends Base {
  @autobind
  showVideoPreviewWithoutRecord(startPreviewCallback, startRecordingWhenReady) {
    const self = this;
    const showPreviewHandle = (stream) => {
      self.streamObj = stream;
      startPreviewCallback
        && startPreviewCallback((videoRef) => {
          self.videoElement = videoRef;
          self.videoElement.srcObject = stream;
          self.videoElement.muted = true;
          // self.videoElement.controls = true;
          self.videoElement.play();
        });

      self.audioVideoRecorder = RecordRTC(stream, {
        type: 'video'
        // audioBitsPerSecond : 128000,
        // videoBitsPerSecond : 2500000,
      });

      if (startRecordingWhenReady) {
        self.audioVideoRecorder.startRecording();
      }
    };

    if (!self.streamObj) {
      this.captureUserMedia00((stream) => {
        showPreviewHandle(stream);
      });
    } else {
      showPreviewHandle(self.streamObj);
    }
  }

  @autobind
  startRecording(startRecordingCallback) {
    const self = this;
    const startRecordingHandle = (stream) => {
      startRecordingCallback
        && startRecordingCallback((videoRef) => {
          self.videoElement = videoRef;
          self.videoElement.srcObject = stream;
          self.videoElement.muted = true;
          // self.videoElement.controls = true;
          self.videoElement.play();
        });

      self.streamObj = stream;
      self.audioVideoRecorder = RecordRTC(stream, {
        type: 'video'
        // audioBitsPerSecond : 128000,
        // videoBitsPerSecond : 2500000,
      });
      self.audioVideoRecorder.startRecording();
    };

    if (!self.streamObj) {
      this.captureUserMedia00((stream) => {
        startRecordingHandle(stream);
      });
    } else {
      startRecordingHandle(self.streamObj);
    }
  }

  @autobind
  cancelRecorded() {
    this.audioVideoRecorder
      && this.audioVideoRecorder.clearRecordedData
      && this.audioVideoRecorder.clearRecordedData();
    // self.streamObj && self.streamObj.stop();
    // self.streamObj = null;
  }

  @autobind
  stopRecording(callback) {
    const self = this;

    this.audioVideoRecorder
      && this.audioVideoRecorder.stopRecording
      && this.audioVideoRecorder.stopRecording((url) => {
        self.streamObj && self.streamObj.stop();
        self.streamObj = null;
        self.videoElement.src = url;
        self.videoElement.muted = false;
        // setTimeout(() => { self.videoElement.play(); }, 150);

        self.videoElement.onended = function () {
          self.videoElement.pause();

          // dirty workaround for: "firefox seems unable to playback"
          // self.videoElement.src = URL.createObjectURL(self.audioVideoRecorder.getBlob());
        };
        // console.log(url);
        callback({ url, blobData: self.audioVideoRecorder.getBlob() });
      });
  }

  @autobind
  captureUserMedia(constraints) {
    return navigator.mediaDevices.getUserMedia(constraints);
  }

  @autobind
  captureUserMedia00(callback) {
    const self = this;
    self
      .captureUserMedia(mediaConstraints)
      .then((stream) => {
        // console.log('user media Callback', stream);
        if (stream.getVideoTracks().length > 0 && stream.getAudioTracks().length > 0) {
          callback(stream);
        } else {
          stream.stop();
          stream = null;
          SnackBarHelper.showSnackbar({
            label:
              'No Audio/Video record support in your browser / You didn\'t "Allow" on browser prompt.',
            duration: 4
          });
        }
      })
      .catch((error) => {
        SnackBarHelper.showSnackbar({
          label:
            'No Audio/Video record support in your browser / You didn\'t "Allow" on browser prompt.',
          duration: 4
        });
        console.log('user media Error ', JSON.stringify(error));
      });
  }

  @autobind
  clearStream() {
    console.log('clearStream called:: ');
    this.streamObj && this.streamObj.stop();
    this.streamObj = null;
  }
}
